import { getLocale } from "@novel/shared/utils/getLocale";

export function numberWithCommas(number: number | bigint, locale?: string): string {
    if (typeof number === "bigint") {
        return BigInt(number).toLocaleString(locale || getLocale());
    } else {
        return new Number(number || 0).toLocaleString(locale || getLocale());
    }
}
